import { css } from 'styled-components'
import { minMq } from '../../shared/styles/breakPoints'


const cards = css`
  display: grid;
  gap: 40px 20px;
  grid-template-columns: repeat(1, 1fr);
  margin-bottom: 72px;

  ${minMq('MD')} {
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    margin-bottom: 80px;
  }
`

const fewerCards = css`
  ${minMq('MD')} {
    grid-template-columns: repeat(auto-fit, 320px);
  }
`

const noData = css`
  margin-bottom: 40px;

  ${minMq('MD')} {
    margin-bottom: 60px;
  }
`

export const style = {
  cards,
  fewerCards,
  noData
}